import React from 'react';
import PropTypes from 'prop-types';

const blockEl = 'ui__tab-panel';

const TabPanel = ({ value, index, children }) => {
  if (value !== index) {
    return null;
  }

  return <div className={blockEl}>{children}</div>;
};

TabPanel.propTypes = {
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  children: PropTypes.node
};

TabPanel.defaultProps = {
  children: null
};

export default TabPanel;
